import {
  LeaderExtendQuery,
  OrderStatusFilterEnum,
  OrderTypes,
} from 'configs/constants';
import { endOfDay, startOfDay } from 'date-fns';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'configs';
import { formatDateTime, normalizedPhoneNumber } from 'utils/helpers/helpers';

export type FilterType = {
  orderCode?: string;
  leader?: string;
  userExec?: string;
  serviceType?: string;
  fromDate?: string | number;
  toDate?: string | number;
  status: 'Hoàn thành' | 'Đang xử lý' | 'Tất cả';
  searchDetailContent?: string;
  refreshData: number;
  pageSize: number;
  pageIndex: number;
};

export const getInitFilterValues = (urlParams: any): FilterType => {
  return {
    orderCode: urlParams?.get('orderCode') ?? '',
    leader: urlParams?.get('leader') ?? LeaderExtendQuery['Tất cả'],
    userExec: urlParams?.get('userExec') ?? '',
    serviceType: urlParams?.get('serviceType') ?? OrderTypes['Tiền điện'],
    fromDate:
      urlParams?.get('fromDate') ?? startOfDay(new Date()).toUTCString(),
    toDate: urlParams?.get('toDate') ?? endOfDay(new Date()).toUTCString(),
    status: urlParams?.get('status') ?? OrderStatusFilterEnum['Tất cả'],
    searchDetailContent: urlParams?.get('searchDetailContent') ?? '',
    refreshData: 0,
    pageSize: Number(urlParams?.get('pageSize') ?? DEFAULT_PAGE_SIZE),
    pageIndex: Number(urlParams?.get('pageIndex') ?? DEFAULT_PAGE_INDEX),
  };
};

// export const initFilterValues: FilterType = {
//   orderCode: '',
//   leader: LeaderExtendQuery['Tất cả'],
//   userExec: '',
//   serviceType: OrderTypes['Tiền điện'],
//   fromDate: startOfDay(new Date()).toUTCString(),
//   toDate: endOfDay(new Date()).toUTCString(),
//   status: OrderStatusFilterEnum['Tất cả'],
//   searchDetailContent: '',
//   refreshData: 0,
// };

export const convertVariables = (variables: FilterType) => {
  const { fromDate, toDate, leader, searchDetailContent, ...rest } = variables;

  const newDateFrom =
    typeof fromDate === 'string' ? new Date(fromDate).getTime() : fromDate;
  const newDateTo =
    typeof toDate === 'string' ? new Date(toDate).getTime() : toDate;

  return {
    ...rest,
    ...(leader && leader === LeaderExtendQuery['Tất cả']
      ? { leader: '' }
      : { leader }),
    fromDate: fromDate ? formatDateTime(Number(newDateFrom)) : '',
    toDate: toDate ? formatDateTime(Number(newDateTo), true) : '',
    ...(searchDetailContent ? { searchDetailContent } : {}),
  };
};

export const convertSelectStatusOptions = () => {
  return Object.keys(OrderStatusFilterEnum).map((key: string) => {
    return {
      label: OrderStatusFilterEnum[key as keyof typeof OrderStatusFilterEnum],
      value: key,
    };
  });
};

export const convertSelectOrderTypeOptions = () => {
  return Object.keys(OrderTypes).map((key: string) => {
    return {
      label: key,
      value: OrderTypes[key as keyof typeof OrderTypes],
    };
  });
};

export const convertSelectLeaderOptions = (data: any[]) => {
  if (!data || !data.length) return [];

  const all = Object.keys(LeaderExtendQuery).map((key: string) => {
    return {
      label: LeaderExtendQuery[key as keyof typeof LeaderExtendQuery],
      value: key,
    };
  });

  const leaders = data?.map((item) => {
    return {
      label: `${item?.fullName}-${normalizedPhoneNumber(item?.phoneNumber as unknown as string)}`,
      value: `${item?.fullName}-${item?.phoneNumber}`,
    };
  });

  return [...all, ...leaders];
};

export const exportHeaders = [
  'STT',
  'Mã đơn hàng',
  'Tài khoản thực hiện',
  'Trưởng nhóm',
  'Loại dịch vụ',
  'Lượng giao dịch',
  'Lượng thành công',
  'Lượng thất bại',
  'Số tiền',
  'Thanh toán',
  'Hoàn trả',
  'Trạng thái',
  'Thời gian',
];
